import { useIonRouter } from "@ionic/react";
import { useHistory } from "react-router-dom";

const TABS = ["today", "train", "food", "progress", "you"];

function tabOf(path: string): string {
  return path.split(/[?#]/)[0].split("/")[1] ?? "";
}

/**
 * A link's navigation. Into another tab it switches tab rather than stacking that tab's page on
 * this one's history (redesign audit §3); within a tab, or to a player, it is an ordinary push.
 */
export function useGo(): (to: string) => void {
  const router = useIonRouter();
  const history = useHistory();
  return (to: string) => {
    const dest = tabOf(to);
    if (TABS.includes(dest) && dest !== tabOf(history.location.pathname)) router.push(to, "root");
    else history.push(to);
  };
}
